<template>
  <header :class="$style.navigation">
    <transition
      is="nav"
      name="nav-animation"
    >
      <router-link
        tag="div"
        to="/"
        rel="home"
        :class="$style.logo"
      />
      <slot name="nav">
        <div style="display: flex; gap: 5px">
          <router-link to="/machines">
            <rg-button
              type="is-primary"
              icon-left="tractor"
              label="Maschinen"
            />
          </router-link>
          <div>
            <router-link to="/accounts">
              <rg-button
                type="is-primary"
                icon="address-book"
                title="Accounts"
                style="
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                "
              />
            </router-link>
            <rg-dropdown>
              <template
                #trigger
              >
                <rg-button
                  icon="chevron-down"
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                  "
                />
              </template>
              <router-link to="/accounts">
                <rg-button
                  icon-left="users"
                  label="Accounts"
                />
              </router-link>
              <router-link to="/companies">
                <rg-button
                  icon-left="industry"
                  label="Unternehmen"
                />
              </router-link>
              <router-link
                to="/associations/"
              >
                <rg-button
                  icon-left="building"
                  label="Unternehmensgruppen"
                />
              </router-link>
            </rg-dropdown>
          </div>
          <router-link to="/permissions">
            <rg-button
              icon="shield-alt"
              title="Berechtigungen"
            />
          </router-link>
          <router-link to="/pricings">
            <rg-button
              icon="dollar-sign"
              title="Preise"
            />
          </router-link>
          <!-- <router-link to="/jaltest">
            <rg-button icon="jaltest" title="Jaltest" />
          </router-link> -->
          <router-link to="/machinetabs">
            <rg-button
              icon="folder-open"
              title="Tabs"
            />
          </router-link>
        </div>
      </slot>
    </transition>
    <transition
      is="div"
      name="nav-animation"
    >
      <slot>
        <rg-button
          icon="angle-double-left"
          :disabled="page <= 1"
          @click="$root.$emit('page-click', 'first')"
        />&nbsp;
        <rg-button
          icon="angle-left"
          :disabled="page <= 1"
          @click="$root.$emit('page-click', 'prev')"
        />&nbsp;
        <rg-button
          icon="angle-right"
          :disabled="page >= last"
          @click="$root.$emit('page-click', 'next')"
        />&nbsp;
        <rg-button
          icon="angle-double-right"
          :disabled="page >= last"
          @click="$root.$emit('page-click', 'last')"
        />&nbsp;
      </slot>
    </transition>
    <div :class="$style.user">
      <div :class="$style.username">
        <span>{{ $store.state.user.firstname || "Rep." }}
          {{ $store.state.user.lastname || "Guide" }}</span>
        <span>{{ $store.state.user.tier || "Keine Nutzerrolle" }}</span>
      </div>
      <rg-dropdown
        ref="navdrop"
        stay
        :width="300"
      >
        <template
          #trigger
        >
          <rg-button
            title="Sitzung erneuern"
            icon="chevron-down"
          />
        </template>
        <rg-button
          title="Zwischen dunkler und heller Darstellung umschalten"
          icon-left="adjust"
          label="Darstellung wechseln"
          @click="toggleTheme()"
        />
        <rg-button
          title="Abmelden"
          type="is-danger"
          icon-left="sign-out-alt"
          label="Abmelden"
          @click="logout()"
        />
        <hr>
        <form @submit.prevent="username && password ? login() : null">
          <p>Melde dich an um deine Sitzung zu erneuern:</p>
          <p>
            <input
              v-model="username"
              placeholder="Benutzername"
              style="width: 100%"
              type="text"
              autocomplete="username"
              @input="status = ''"
            >
          </p>
          <p>
            <input
              v-model="password"
              placeholder="Passwort"
              style="width: 100%"
              type="password"
              autocomplete="current-password"
              @input="status = ''"
            >
          </p>
          <rg-button
            v-if="status"
            disabled
            :icon-left="
              status === 'Sitzung erfolgreich erneuert'
                ? 'check'
                : 'exclamation-triangle'
            "
            :label="status"
          />
          <rg-button
            v-else
            :disabled="!username || !password"
            title="Sitzung erneuern"
            icon-left="redo"
            label="Sitzung erneuen"
            @click="login()"
          />
        </form>
      </rg-dropdown>
    </div>
  </header>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import dropdown from "@/components/elements/rg-dropdown";
// import { randomBytes, createHash, createCipheriv } from "crypto";

export default {
  name: "RgControl",
  components: { "rg-dropdown": dropdown },

  setup(props, context) {
    let page = ref(0);
    let last = ref(0);
    let username = ref("");
    let password = ref("");
    let status = ref("");
    let timeout = null;

    onMounted(() => {
      context.root.$on("current-page", (arg) => {
        page.value = arg;
      });
      context.root.$on("last-page", (arg) => {
        last.value = arg;
      });
    });

    function login() {
      const trimmedUsername = username.value.trim().toLowerCase();
      if (trimmedUsername !== "" && password.value !== "") {
        // const resizedIv = Buffer.allocUnsafe(16);
        // const shaKey = randomBytes(16).toString("hex");
        // const iv = createHash("sha256")
        //   .update(trimmedUsername + "u&g4n!6gs")
        //   .digest();
        // iv.copy(resizedIv);
        // const key = createHash("sha256").update(shaKey).digest();
        // const cipher = createCipheriv("aes256", key, resizedIv);
        // cipher.update(password.value.trim(), "binary", "hex");
        // const pwd = cipher.final("hex");

        context.root.$store
          .dispatch("login", {
            username: trimmedUsername,
            password: btoa(password.value),
          })
          .then(() => {
            status.value = "Sitzung erfolgreich erneuert";
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              status.value = "";
              context.refs.navdrop.close();
            }, 1000);
          })
          .catch(() => {
            status.value = "Bitte überprüfe deine Eingabe";
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              status.value = "";
            }, 2000);
          });
      }
    }

    function logout() {
      context.root.$store.dispatch("logout").then(() => {
        context.root.$router.push("/login");
      });
    }

    function toggleTheme() {
      const newVal =
        (localStorage.getItem("theme") || "light") === "light"
          ? "dark"
          : "light";
      localStorage.setItem("theme", newVal);
      document.documentElement.setAttribute("data-theme", newVal);
    }

    return {
      page,
      last,
      logout,
      toggleTheme,
      username,
      password,
      login,
      status,
    };
  },
};
</script>

<style lang="scss" module>
.navigation {
  -webkit-app-region: drag;
  width: 100%;
  height: 69px;
  background: var(--card-opague);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 8px;
  position: sticky;
  top: 0;
  z-index: 99999999999999;
  border-bottom: 1px solid rgba(150 150 150 / 0.5);
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    .logo {
      width: 25px;
      margin: 0 15px 0 10px;
      height: 100%;
      cursor: pointer;
      background: url("data:image/png;base64,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")
        center / contain no-repeat;
    }
  }
  .user {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .username {
      margin-right: 10px;
      span {
        display: block;
        text-align: right;
      }
      span:first-of-type {
        font-size: 20px;
      }
      span:last-of-type {
        font-size: 14px;
        letter-spacing: 1.2px;
        text-transform: uppercase;
        color: rgba(150 150 150 / 0.7);
      }
    }
  }
}
[data-theme="dark"] .logo {
  filter: invert(100%);
}
</style>

<style lang="scss">
.nav-animation-enter-active,
.nav-animation-leave-active {
  transform: translateY(-50%) scale(1);
  transition: all 2s ease !important;
}
.nav-animation-enter,
.nav-animation-leave-to {
  opacity: 0;
  transform: translateY(-50%) scale(0.8) !important;
}
</style>